export const ROL_ENUM = {
  ADMIN: 1,
  CLIENTE: 2,
  VENDEDOR: 3,
};      